import { Constants } from "appConstants";
import { Select } from "components";
import useStandardToast from "hooks/useStandardToast";
import { Tenant } from "models/tenant/Tenant";
import { useCallback, useEffect, useMemo, useState } from "react";
import { TenantService } from "services";
import { useTenant } from "store/contextTenant";

type TypeFieldTenants = {
	label: string;
	value: string;
	text: string;
};

export default function TenantIdSelectInput() {
	const { tenant, setTenant } = useTenant();
	const [tenantOptions, setTenantOptions] = useState<TypeFieldTenants[]>([]);
	const { showErrorToast } = useStandardToast();

	const tenantService = useMemo(() => new TenantService(), []);

	const convertTenantsToOptionsFields = (tenentList: Tenant[]) => {
		const FieldTenants = tenentList.map((tenantresponse) => ({
			label: tenantresponse.name,
			value: tenantresponse.id,
			text: ""
		}));
		if (FieldTenants) {
			setTenant(FieldTenants[0]);
		}
		setTenantOptions(FieldTenants);
	};

	const fetchTenants = useCallback(() => {
		tenantService
			.getList(null)
			.then((response: any) => {
				convertTenantsToOptionsFields(response.content);
			})
			.catch(() => {
				showErrorToast(Constants.strings.errors.failedToGetTenantTypes);
				setTenantOptions([]);
			});
	}, []);

	useEffect(() => {
		fetchTenants();
	}, []);

	return (
		<>
			<div className="divider" />
			<Select
				name="Tenant"
				isClearable={false}
				hideOptional
				options={tenantOptions}
				value={tenant}
				setFieldValue={(_, value) => setTenant(value)}
			/>
		</>
	);
}
